import { useEffect, useState } from "react";

export function useBrowserOnline() {
    const [isBrowserOnline, setIsBrowserOnline] = useState(() => typeof navigator === "undefined" || navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsBrowserOnline(true);
        const handleOffline = () => setIsBrowserOnline(false);

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    return isBrowserOnline;
}

function useDelayedBoolean(value, delayMs) {
    const [delayedValue, setDelayedValue] = useState(false);

    useEffect(() => {
        if (!value) {
            setDelayedValue(false);
            return undefined;
        }

        const timerId = window.setTimeout(() => {
            setDelayedValue(true);
        }, delayMs);

        return () => window.clearTimeout(timerId);
    }, [delayMs, value]);

    return delayedValue;
}

export function useConnectionWarning({ connectionReady = true, isConnected = true, delayMs = 1500 } = {}) {
    const isBrowserOnline = useBrowserOnline();
    const showWebSocketDisconnected = useDelayedBoolean(
        Boolean(connectionReady && isBrowserOnline && !isConnected),
        delayMs,
    );

    return {
        isBrowserOnline,
        showNetworkDisconnected: !isBrowserOnline,
        showWebSocketDisconnected,
    };
}

export default useConnectionWarning;
